import React from 'react';

export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 20 20"
    {...props}
  >
    <defs>
      <style>{".prefix__plus-2{fill:#242325}"}</style>
    </defs>
    <g id="prefix__Group_1029" data-name="Group 1029">
      <g id="prefix__Ellipse_66" data-name="Ellipse 66">
        <circle
          id="prefix__Ellipse_67"
          data-name="Ellipse 67"
          cx={10}
          cy={10}
          r={10}
          fill="#fff"
        />
      </g>
      <g id="prefix__Group_1172" data-name="Group 1172">
        <g id="prefix__Group_1171" data-name="Group 1171">
          <g id="prefix__Group_1175" data-name="Group 1175">
            <g id="prefix__Group_1173" data-name="Group 1173">
              <g id="prefix__Path_3010" data-name="Path 3010">
                <path
                  id="prefix__Path_3036"
                  data-name="Path 3036"
                  className="prefix__plus-2"
                  d="M4.57 15.4a7.66 7.66 0 1110.83 0 7.66 7.66 0 01-10.83 0zm10.2-10.21a6.78 6.78 0 100 9.59 6.77 6.77 0 000-9.59z"
                />
              </g>
            </g>
            <path
              id="prefix__Path_3037"
              data-name="Path 3037"
              className="prefix__plus-2"
              d="M10.93 11.43h2.35a1.19 1.19 0 001.2-1.19A1.2 1.2 0 0013.28 9h-2.34V6.69a1.2 1.2 0 10-2.4 0V9H6.19A1.19 1.19 0 005 10.23a1.21 1.21 0 00.35.85 1.19 1.19 0 00.85.35h2.34v2.35a1.19 1.19 0 00.35.85 1.21 1.21 0 00.85.35 1.19 1.19 0 001.19-1.2z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
  );
};
